import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { integrationsStateSelector } from "./integrationsStateSelector";

export const currentIntegrationResourceTypeSelector = createDraftSafeSelector(
  [integrationsStateSelector],
  (integrations) => {
    return integrations.resourceType;
  },
);
